import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=daike；独立窗正式 key/path 为 canteen（紫金餐厅收银） */
export const daikeModule: AiAppCenterModule = {
  key: 'canteen',
  label: 'AI智慧餐厅',
  desc: '收银台 / 订单管理 / 会员核销',
  path: '/canteen',
  standalonePath: '/canteen/home',
  homePath: '/canteen/home',
  // 侧栏菜单仍挂在后端 /canteen 下
  menuPaths: ['/canteen'],
  icon: 'ep:food',
  color: '#00acac',
  aliases: ['AI智慧餐厅', 'AI智慧收银', '紫金餐厅收银', '代客点餐']
}
